<template>
	<div class="compass" id="compass">
		<img class="compass-image" src="/images/istanbul-outline.png" alt="">
		<router-link to="/acacia" class="compass-leg leg-n"></router-link>
		<router-link to="/acacia" class="compass-leg leg-ne"></router-link>
		<router-link to="/acacia" class="compass-leg leg-e"></router-link>
		<router-link to="/acacia" class="compass-leg leg-se"></router-link>
		<router-link to="/acacia" class="compass-leg"></router-link>
		<router-link to="/acacia" class="compass-leg"></router-link>
		<router-link to="/acacia" class="compass-leg"></router-link>
		<router-link to="/acacia" class="compass-leg"></router-link>

	</div>
</template>

<script>
	export default {
		name: "Compass"
	}
</script>

<style scoped>


	.compass {
		position: relative;
		top: 50vh;

	}

	.compass-image {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: 100%;
	}

	.compass-leg {
		height: 550px;
		width: 54px;
		background-color: black;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);

		transition: background-color 0s;
		cursor: pointer;
		outline: 1px solid black;
		border: 7px solid black;
	}

	.compass-leg:hover {
		background-color: #00ff19;
		transition: background-color .5s;

		z-index: 5;
	}

	.leg-ne {
		-webkit-transform: rotate(45deg);
		-moz-transform: rotate(45deg);
		-ms-transform: rotate(45deg);
		-o-transform: rotate(45deg);
		transform: translate(-50%, -50%) rotate(45deg);
		height: 400px;

	}

	.leg-e {
		-webkit-transform: rotate(90deg);
		-moz-transform: rotate(90deg);
		-ms-transform: rotate(90deg);
		-o-transform: rotate(90deg);
		transform: translate(-50%, -50%) rotate(90deg);
	}

	.leg-se {
		-webkit-transform: rotate(135deg);
		-moz-transform: rotate(135deg);
		-ms-transform: rotate(135deg);
		-o-transform: rotate(135deg);
		transform: translate(-50%, -50%) rotate(135deg);
		height: 400px;

	}


	@media (hover: none) {
		.compass {
			display: none;
		}
	}
</style>